// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './LoaderDiamondIcon.style';

export class LoaderDiamondIcon extends PureComponent {
    static propTypes = {
        // TODO: implement prop-types
    };

    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="1200px" height="1200px" viewBox="0 0 12000 12000" preserveAspectRatio="xMidYMid meet">
                <g id="layer101" fill="#666666" stroke="none">
                    <path d="M5940 8192 c-39 -27 -2846 -2844 -2859 -2869 -6 -12 -11 -55 -11 -95 l0 -74 419 -630 c296 -443 431 -637 457 -656 l37 -28 2062 0 2062 0 37 28 c27 19 160 211 457 657 l419 629 0 74 c0 40 -5 83 -11 95 -13 25 -2820 2842 -2859 2869 -19 13 -45 18 -105 18 -60 0 -86 -5 -105 -18z m1350 -2918 l22 -34 -1264 0 -1263 0 630 1266 630 1266 612 -1232 c337 -677 622 -1247 633 -1266z m-2126 1216 l-622 -1250 -626 0 -626 0 1247 1250 c685 688 1247 1250 1248 1250 0 0 -279 -562 -621 -1250z m2389 0 l1247 -1250 -626 0 -626 0 -622 1250 c-342 688 -621 1250 -621 1250 1 0 563 -562 1248 -1250z m-3130 -1487 c-11 -16 -54 -102 -98 -193 -113 -237 -326 -663 -329 -659 -2 2 -134 201 -295 442 l-291 437 516 0 515 0 -18 -27z m2816 23 c-15 -13 -1190 -856 -1194 -856 -4 0 -1179 843 -1194 856 -2 2 535 4 1194 4 659 0 1196 -2 1194 -4z m1150 -433 c-161 -241 -293 -440 -295 -442 -3 -4 -216 422 -329 659 -44 91 -87 177 -98 193 l-18 27 515 0 516 0 -291 -437z m-2889 -296 c168 -121 316 -228 329 -238 23 -19 3 -19 -811 -19 l-835 0 220 444 219 443 287 -205 c157 -113 423 -304 591 -425z m1993 -255 c-226 -1 -601 -1 -832 0 l-420 3 465 335 c256 184 532 383 612 441 l147 107 220 -442 220 -441 -412 -3z" />
                </g>
            </svg>
        );
    }
}

export default LoaderDiamondIcon;
